function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.747036 2.49012C0.747036 1.52744 1.52744 0.747036 2.49012 0.747036H19.6798C21.6052 0.747036 23.166 2.30785 23.166 4.2332V18.5059C23.166 18.9185 22.8315 19.253 22.419 19.253H2.49012C1.52744 19.253 0.747036 18.4726 0.747036 17.5099V2.49012Z",
  stroke: "white",
  strokeWidth: 1.49407
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-132",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.3467 5.15912C19.3467 4.47149 19.9041 3.91406 20.5917 3.91406H24.0838C27.5907 3.91406 30.4336 6.75697 30.4336 10.2639V19.254C30.4336 19.6666 30.0992 20.001 29.6866 20.001H20.0937C19.6811 20.001 19.3467 19.6666 19.3467 19.254V5.15912Z"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3467 5.15912C19.3467 4.47149 19.9041 3.91406 20.5917 3.91406H24.0838C27.5907 3.91406 30.4336 6.75697 30.4336 10.2639V19.254C30.4336 19.6666 30.0992 20.001 29.6866 20.001H20.0937C19.6811 20.001 19.3467 19.6666 19.3467 19.254V5.15912Z",
  fill: "#BBD422",
  stroke: "white",
  strokeWidth: 2.98814,
  mask: "url(#path-2-inside-132)"
});

var _ref5 = /*#__PURE__*/React.createElement("mask", {
  id: "path-3-inside-21111",
  fill: "white"
}, /*#__PURE__*/React.createElement("rect", {
  x: 22.3916,
  y: 8.04297,
  width: 8.04348,
  height: 4.78261,
  rx: 0.996047
}));

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 22.3916,
  y: 8.04297,
  width: 8.04348,
  height: 4.78261,
  rx: 0.996047,
  stroke: "white",
  strokeWidth: 2.98814,
  mask: "url(#path-3-inside-21111)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.90486 19.5669C9.90486 20.8352 8.87671 21.8634 7.60842 21.8634C6.34013 21.8634 5.31198 20.8352 5.31198 19.5669C5.31198 18.2986 6.34013 17.2705 7.60842 17.2705C8.87671 17.2705 9.90486 18.2986 9.90486 19.5669Z",
  fill: "#BBD422",
  stroke: "white",
  strokeWidth: 1.49407
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M26.2091 19.5669C26.2091 20.8352 25.1809 21.8634 23.9126 21.8634C22.6443 21.8634 21.6162 20.8352 21.6162 19.5669C21.6162 18.2986 22.6443 17.2705 23.9126 17.2705C25.1809 17.2705 26.2091 18.2986 26.2091 19.5669Z",
  fill: "#BBD422",
  stroke: "white",
  strokeWidth: 1.49407
});

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.4cd228b4.svg";
export { ForwardRef as ReactComponent };